import classnames from "classnames";
import React, { type FC, useContext } from "react";
import { DocumentComplianceContext } from "src/components/Contexts/DocumentComplianceContext";
import DataTable from "src/components/DataTable";
import documentComplianceDataTableDefinition from "src/components/Pages/DocumentInbound/Tabs/Validations/DocumentCompliance/DocumentComplianceListing/document-compliance-data-table-definition";
import styles from "src/styles.module.scss";

const DocumentValidationListing: FC = () => {
  const { validationGroups } = useContext(DocumentComplianceContext);

  return (
    <div
      className={classnames(
        styles.flex,
        styles.flex_direction_row,
        styles.flex_nowrap,
        styles.w_80,
        styles.justify_start
      )}
    >
      <DataTable
        id="document-validation"
        tableDefinition={documentComplianceDataTableDefinition}
        contents={validationGroups}
      />
    </div>
  );
};

export default DocumentValidationListing;
